// "Configure BOQ" — the runtime, per-browser switch (next to the
// Re-calculate button on `/groundworks/review`) that lets a user toggle
// whether "Add Section"/"Add Item" is available across every groundworks
// Bill Summary and the Dynamic Bill Summary tabs. Replaces the old
// build-time-only `VITE_DYNAMIC_SUMMARY` env flag — that env key and the
// `DYNAMIC_SUMMARY_ENABLED` constant it fed are both removed; components
// read `useConfigureBoq()` (contexts/ConfigureBoqContext.tsx) instead.
export const CONFIGURE_BOQ_STORAGE_KEY = "mj_configure_boq";
export const CONFIGURE_BOQ_SWITCH_LABEL = "Configure BOQ";
